import styled from 'styled-components';
import { Button } from '_components/_core';

export const RequiredIndicator = styled.span`
  color: #ff0000;
  font-weight: 600;
  margin-left: 4px;
`;

export const StyledButton = styled(Button)`
  min-width: 120px;
`;
